import { useContext } from 'react'
import { LangContext, langLabels } from '../contexts/Lang.context'
import { ChangeEvent, LANG } from '@bm-js/atlascloud-shared'
import Select from './Select'

const LanguageSelector = () => {
  const { availableLangs, currentLang, changeLang } = useContext(LangContext)

  const handleChangeLang = (e: ChangeEvent) => {
    const isValid = availableLangs.includes(e.target.value as LANG)
    if (!isValid) return
    changeLang(e.target.value as LANG)
  }
  return (
    <Select
      className='mt-4 max-w-[400px]'
      light
      value={currentLang}
      onChange={handleChangeLang}
    >
      {availableLangs.map((lang) => (
        <option key={lang} value={lang}>
          {langLabels[lang]}
        </option>
      ))}
    </Select>
  )
}

export default LanguageSelector
